import { render, staticRenderFns } from "./BuyPartsPage.vue?vue&type=template&id=60031238&scoped=true&"
import script from "./BuyPartsPage.vue?vue&type=script&lang=js&"
export * from "./BuyPartsPage.vue?vue&type=script&lang=js&"
import style0 from "./BuyPartsPage.vue?vue&type=style&index=0&id=60031238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60031238",
  null
  
)

export default component.exports